export default "__VITE_ASSET__c3f88764__"